var React = require('react');

function IconGlassdoor (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.7981 16.2894H0.0127897C0.0127897 17.791 1.21536 19 2.71062 19H10.7981C12.287 19 13.4896 17.7846 13.4896 16.2894V5.14128C13.4896 5.09034 13.4452 5.03962 13.3942 5.03962H10.8935C10.8426 5.03962 10.7981 5.08405 10.7981 5.14128V16.2894ZM10.7981 0C12.287 0 13.4896 1.21536 13.4896 2.71706H2.70431V13.865C2.70431 13.916 2.65977 13.9669 2.60252 13.9669H0.101856C0.0509168 13.9669 0 13.9223 0 13.865V2.71706C0 1.21536 1.20266 0 2.69798 0H10.7981Z","fill":"#2D2926"}));
}

IconGlassdoor.defaultProps = {"viewBox":"0 0 14 19"};

module.exports = IconGlassdoor;

IconGlassdoor.default = IconGlassdoor;
